<template>
    <div class="register-comp">
        <div class="register-header">
            <div id="register_logo">
                <img class="" src="@/assets/logo/cpf-logo.png" />
            </div>
        </div>
        <div class="register-body">
            <div class="register-headline theme-txt">{{lbl.contact_number.name}}</div>
            <div id="register_input">
                <div class="label-register">
                    {{ lbl.contact_number.name }}
                </div>
                <div class="input-wrapper">
                    <input type="tel"
                        :class="{'input-error': isSubmitted && !isValid}"
                        :maxlength="12"
                        v-model="displayContactNumber"
                        @input="onChange()"
                        @click="onTracking()" />
                    <div class="input-placeholder"
                        v-show="!displayContactNumber">
                        {{lbl.contact_number.placeholder}}
                    </div>
                </div>
                <div class="input-error-txt"
                    v-if="isSubmitted && !isValid">
                    {{errMsg}}
                </div>
            </div>
            <div :class="[isSubmitted && !isValid ? 'btn-margin-error':'btn-margin']">
                <div id="register_request_otp_wrapper" class="btn-wrapper" >
                    <div class="btn-txt"
                        @click="submitOtp">{{lbl.enter_contact_number_btn}}
                    </div>
                </div>
            </div>
            <div id="cpf-register-logo">
                <img class="page-logo" src="../../../assets/bzbslogo/new-logo-gray.png" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Util from '@/helper/Utility.js';

export default {
    name: 'register-contact-number',
    props: {
        lbl: Object,
        modalController: Object,
        theme: String,
    },
    data: function () {
        return {
            contactNumber: null,
            displayContactNumber: null,
            maxLength: 12,
            delimeter: '-',
            isSubmitted: false,
            isValid: false,
            errMsg: '',
        };
    },
    methods: {
        //Event
        submitOtp: function () {
            this.isSubmitted = true;
            //TODO: Validate.
            this.validateInput();
            if (this.isValid) {
                this.$emit("submitOtp", {
                    contactNumber: this.contactNumber,
                    displayContactNumber: this.displayContactNumber
                });
                this.$emit("onTracking", "click_send_otp");
            }
        },
        //Method
        validateInput: function () {
             //Set default.
            this.isValid = true;
            this.errMsg = '';
            //Required
            if(this.lbl.contact_number.required
                && !this.displayContactNumber) {

                this.isValid = false;
                this.errMsg = this.lbl.contact_number.required;
                return;
            }
            //Too short
            if(this.lbl.contact_number.too_short
                && this.displayContactNumber < this.maxLength) {

                this.isValid = false;
                this.errMsg = Util.stringFormat(this.lbl.contact_number.too_short, this.maxLength);
                return;
            }
            //InValid format
            if(this.lbl.contact_number.invalid) {
                // Delete delimeter 3 time without Regx.
                // Usually regx will find all text and replace all with /regx/g but this one per time.
                var contactnumber = this.displayContactNumber.replace(this.delimeter,'');
                contactnumber = contactnumber.replace(this.delimeter,'');
                contactnumber = contactnumber.replace(this.delimeter,'');

                if(!Vue.validator.validateContactNumber(contactnumber)) {
                    this.isValid = false;
                    this.errMsg = this.lbl.contact_number.invalid;
                    return;
                }
            }
        },
        onChange: function() {
            if (!this.displayContactNumber) return;
            if (this.displayContactNumber[0] != 0) {
                this.displayContactNumber = '';
                return;
            }

            var input = this.displayContactNumber || '';
            input = input.replace(Vue.RegExp.emoji, '');
            input = input.replace(Vue.RegExp.notNumber, '');

            this.validateInput();
            if (Util.isEmptyStr(this.delimeter)) {
                this.displayContactNumber = input;
                //this.$emit("input", input);
            } else {
                var n1, n2, n3;
                var formatted = input;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }

                this.contactNumber = formatted;
                this.displayContactNumber = input;
                //this.$emit("input", formatted);
            }
        },
        //Modal
        showAlert: function (title, msg, btn) {
            this.modalController.alertModal
                    .clearText()
                    .setTitle(title)
                    .setMsg(msg)
                    .setBtnOk(btn)
                    .setTag('alert-register-contact-number')
                    .show();
        },
        responseError: function (title, msg, btn, callback) {
            this.modalController.alertModal
                    .clearText()
                    .setTitle(title)
                    .setMsg(msg)
                    .setBtnOk(btn)
                    .setTag('alert-register-contact-number')
                    .show();

            this.modalController.alertModal.onClickOk(callback);
        },
        onTracking: function () {
            this.$emit("onTracking", "click_input_phone");
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "@/style/base/base.scss";
    .register-body {
        height: 90vh;
    }
    #register_input {
        @include baseInput;
        margin-bottom: 0px;

        .label-register {
            color: $a-gray-575757;
            font-size: 1.5rem;
        }

        @media (max-width: $max-width-mini-mobile) {
            margin-bottom: 40px;
        }

        .input-wrapper {
            input {
                text-align: left;
            }

            .input-placeholder {
                text-align: left;
            }
        }
    }

    .register-headling {
        margin-bottom: 25px;
    }
    .btn-margin {
        margin-top: 50px;
    }
    .btn-margin-error {
        margin-top: 11px;
    }

</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
    #cpf-register-logo {
        margin: auto;
        .page-logo {
            position: absolute;
            left: 0;
            bottom: 38px;
            right: 0;
            margin: auto;
            width: 88px;
            height: 18px;
        }
    }
    
    // @media screen and (min-height: 0px) and (max-height: 550px) {
    //     #cpf-register-logo { display: none; }  /* show it on small screens */
    // }
</style>
